import type { HelpWidgetMessage } from "../types/help_widget_message";

export const shouldShowFadingTextEffect = (msg: HelpWidgetMessage): boolean =>
  ["circle_bot", "copilot"].includes(msg.channel) &&
  msg.author_type === "bot" &&
  !!msg.content?.trim();

export const messageWithFadingEffect = (
  msg: HelpWidgetMessage,
): HelpWidgetMessage => ({
  ...msg,
  show_fading_text_effect: shouldShowFadingTextEffect(msg),
});
